
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import imgup from '@/assets/upload_img.png'
import { getAccountDetail } from '@/api/youzheng.js'
import { getSex } from '@/api/sys.js'
import { getConfig, addFile } from '@/api/wx.js'
import Storage from '@/storage'
import store from '@/store'
import config from '@/config/index'
export default {
directives: {
TransferDom
},
name: 'myMailDetail',
data () {
return {
upimagelist:[],
imgcount:5,
fileList:{fileUrlArr: [],fileIdArr: []},
imgup:imgup,
id:this.$route.params.id,
obj:{
userstatusNAME:'',
userstatus:'',
userstatusNAME:'',
title:'',
content:'',
fileldList:'',
createdate:'',
deallinker:'',
dealdate:'',
dealmsg:'',
dealdept:'',
dealfileids:''
},
baseUrl:config.baseUrl,
showToast:false,
previewSrc:''
}
},
components: {
Popup,
Group,
Cell,
XInput,
Selector,
PopupRadio,
XAddress,
XTextarea,
XSwitch,
Flexbox,
FlexboxItem,
XButton,
Tabbar,
TabbarItem,
XDialog
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {
getDetail(){
getAccountDetail({
accountid:this.accountid,
id:this.id
}).then(res=>{
this.obj = res.returnValue
})
},
closepage(){
this.$router.go(-1)
},
preview(src){
this.showToast = true
this.previewSrc = src
}
},
activated () {},
created () {
this.getDetail()
}
}
